import Get from '../services/Get';

import { nexcareVersion } from '../config/serviceConfig';

const getDataDashboard = (userCategory, month, year, id, token) => Get(`/${nexcareVersion}/nexcare/ticket/dashboard/${userCategory}/all?month=${month}&year=${year}&list_cs_id=${id}`, token);
const getInitiateDashboard = (month, year, token) => Get(`/${nexcareVersion}/nexcare/ticket/dashboard/initiate-data?month=${month}&year=${year}`, token);
const getAllTicket = (userCategory, id, inputtedAt, token) => Get(`/${nexcareVersion}/nexcare/ticket/dashboard/${userCategory}?list_cs_id=${id}&inputted_at=${inputtedAt}`, token);
const getTotalOnline = (userCategory, filter, token) => Get(`/${nexcareVersion}/nexcare/dashboard/${userCategory}/total-cs-online?${filter}&onlineCSOnly=true&csoOnly=true`, token);
const getEscalationTicket = (userCategory, id, inputtedAt, token) => Get(`/${nexcareVersion}/nexcare/ticket/dashboard/${userCategory}/escalation?list_cs_id=${id}&inputted_at=${inputtedAt}`, token);
const getCompletionTicket = (userCategory, id, inputtedAt, token) => Get(`/${nexcareVersion}/nexcare/ticket/dashboard/${userCategory}/completion?list_cs_id=${id}&inputted_at=${inputtedAt}`, token);
const getCompletionTicketDetail = (userCategory, id, inputtedAt, token) => Get(`/${nexcareVersion}/nexcare/ticket/dashboard/${userCategory}/completion/detail?list_cs_id=${id}&inputted_at=${inputtedAt}`, token);
const getAverageResolutionTime = (userCategory, id, inputtedAt, token) => Get(`/${nexcareVersion}/nexcare/ticket/dashboard/${userCategory}/resolution-time-average?list_cs_id=${id}&inputted_at=${inputtedAt}`, token);
const getSLAResolutionTime = (userCategory, id, inputtedAt, token) => Get(`/${nexcareVersion}/nexcare/ticket/dashboard/${userCategory}/sla?list_cs_id=${id}&inputted_at=${inputtedAt}`, token);
const getAverageResponseTime = (userCategory, id, inputtedAt, token) => Get(`/${nexcareVersion}/nexcare/ticket/dashboard/${userCategory}/response-time-average?list_cs_id=${id}&inputted_at=${inputtedAt}`, token);
const getTrendVolumeTicket = (userCategory, month, year, date, token) => Get(`/${nexcareVersion}/nexcare/ticket/dashboard/${userCategory}/trend?page=1&limit=100&month=${month}&year=${year}&date=${date}`, token);
const getCommission = (token) => Get(`/${nexcareVersion}/nexcare/ticket/dashboard/cso/commission`, token);

const API_DASHBOARD = {
    getDataDashboard,
    getInitiateDashboard,
    getAllTicket,
    getTotalOnline,
    getEscalationTicket,
    getCompletionTicket,
    getCompletionTicketDetail,
    getAverageResolutionTime,
    getSLAResolutionTime,
    getAverageResponseTime,
    getTrendVolumeTicket,
    getCommission

}

export default API_DASHBOARD;